export default __webpack_public_path__ + "static/media/Soumya.950a0f0d.jpeg";